import React from 'react'
import { Plus, Minus } from 'lucide-react'
import mapboxgl from 'mapbox-gl'

interface ZoomControlProps {
  map: mapboxgl.Map | null
  className?: string
}

export function ZoomControl({ map, className = '' }: ZoomControlProps) {
  const handleZoomIn = () => {
    if (!map) return
    map.zoomIn()
  }

  const handleZoomOut = () => {
    if (!map) return
    map.zoomOut()
  }

  if (!map) return null

  const isEmbed = className.includes('embed-control')

  if (isEmbed) {
    // Embed style - matches other embed controls
    return (
      <>
        <button
          onClick={handleZoomIn}
          className={className}
          style={{ 
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
          title="Zoom in"
          type="button"
        >
          <Plus className="w-[18px] h-[18px]" strokeWidth={3} />
        </button>
        <button
          onClick={handleZoomOut}
          className={className}
          style={{ 
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
          title="Zoom out"
          type="button"
        >
          <Minus className="w-[18px] h-[18px]" strokeWidth={3} />
        </button>
      </>
    )
  }

  // Regular style for non-embed
  return (
    <>
      <button
        onClick={handleZoomIn}
        className={`${className} bg-gray-200 hover:bg-gray-300 transition-colors flex items-center justify-center`}
        style={{ 
          width: '32px', 
          height: '32px',
          borderBottom: '1px solid rgba(0,0,0,0.1)'
        }}
        title="Zoom in"
      >
        <Plus className="w-4 h-4 text-gray-700" strokeWidth={3} />
      </button>
      <button
        onClick={handleZoomOut}
        className={`${className} bg-gray-200 hover:bg-gray-300 transition-colors flex items-center justify-center`}
        style={{ 
          width: '32px', 
          height: '32px' 
        }}
        title="Zoom out"
      >
        <Minus className="w-4 h-4 text-gray-700" strokeWidth={3} />
      </button>
    </>
  )
}